var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCamera(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 166,
    height: 120,
    viewBox: "0 0 166 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_9483_3870)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M34.5833 120H89.9167C108.986 120 124.5 103.178 124.5 82.5V37.5C124.5 16.8225 108.986 0 89.9167 0H34.5833C15.5141 0 0 16.8225 0 37.5V82.5C0 103.178 15.5141 120 34.5833 120ZM166 32.3475V87.24C166 92.9175 163.095 98.0175 158.412 100.552C156.455 101.61 154.352 102.135 152.263 102.135C149.352 102.135 146.474 101.122 144.04 99.1425C143.784 98.9325 138.333 93.0675 138.333 93.0675V26.58C138.333 26.58 143.77 20.6625 144.04 20.445C148.217 17.04 153.716 16.4925 158.412 19.035C163.109 21.5775 166 26.67 166 32.3475Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_9483_3870"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 166,
    height: 120,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCamera);
export default __webpack_public_path__ + "static/media/camera.f52e47b010abc1edec22c64d74461634.svg";
export { ForwardRef as ReactComponent };